import {defineStore} from 'pinia';
import {ModuleStock} from '../../moduleConst';
import StockAPI from '@/apis/di/stockAPI';
import {BaseDictionaryStore} from './../../baseDictionaryStore';
const StockStore = new BaseDictionaryStore(StockAPI);
export const useStockStore = defineStore(ModuleStock, {
  state: () => ({
    ...StockStore.state,
    _config: {
      key: 'stock_id',
      code: 'stock_code',
      name: 'stock_name',
      table: 'di_stock',
      moduleName: 'Kho',
      quickFollow: 'active',
      defaultSort: 'stock_code'
    },
    moduleName: 'stock',
  }),
  actions: {
    ...StockStore.action,
    /**
     * Hàm cung cấp dữ liệu stock cho store khác muốn dùng
     * @returns
     */
    provideDataStock() {
      return this.$state.items;
    },
  },
  getters: {
    ...StockStore.getters,
  },
});
